<script>
import {
    mapActions,
    mapGetters
} from "vuex";
export default {
    computed: {
        ...mapGetters({
            settings: "getSettings",
	    lmsUser: "getUser",
        }),
        tenantLogo() {
           // return this.settings.tenant_logo != null ? this.settings.tenant_logo : "";
	   var standard_tenant_logo = this.settings.tenant_logo != null? this.settings.tenant_logo : "";
           var user_program = this.lmsUser.default_program;
           var final_logo = user_program == '5a1113d6-3924-41e6-b815-daad0bc005e1' ? 'https://edclearn-images.nyc3.cdn.digitaloceanspaces.com/logos/Mtn-New-Logo.jpg' : standard_tenant_logo;
           return final_logo;
        },
        tenantCompany() {
            return this.settings.tenant.company_name != null ? this.settings.tenant.company_name : "";
        },
        landingLogo() {
            return this.settings.tenant_landing_logo != null ? this.settings.tenant_landing_logo : "";
        },
        landingDesc() {
            return this.settings.landing_banner_description != null ?
                this.settings.landing_banner_description :
                "Banner Description not set";
        },
        colorTheme() {
           // return this.settings.color_theme != null ? this.settings.color_theme : "#0B85E4";
       	    var standard_color_theme = this.settings.color_theme != null? this.settings.color_theme : "#0B85E4";
            var user_program = this.lmsUser.default_program;
            var final_color_theme = user_program == '5a1113d6-3924-41e6-b815-daad0bc005e1' ? '#F7C505' :standard_color_theme;
            return final_color_theme;
	},
        contactEmail() {
            return this.settings.contact_email !== null ?
                this.settings.contact_email :
                "Contact Email not set";
        },
        landingBanner() {
            return this.settings.landing_banner !== null ?
                this.settings.landing_banner :
                "https://res.cloudinary.com/lms-edc/image/upload/v1594832642/Assets/g01l5a6yudxeb25dte1n.png";
        },
        contactPhone1() {
            return this.settings.contact_phone_1 !== null ?
                this.settings.contact_phone_1 :
                "Contact Phone not set";
        },
        btnColor() {
            return this.settings.banner_button_color !== null ?
                this.settings.banner_button_color :
                `#fff`;
        },
        loginCatchWord() {
            return this.settings.login_catch_word != null ?
                this.settings.login_catch_word :
                "Build skills for today, tomorrow, and beyond.";
        },
        testimonialText() {
            return this.settings.testimonial_action_text !== null ?
                this.settings.testimonial_action_text :
                "Lorem Ipsum";
        },
        learnerRegistration() {
            return this.settings.learner_registration != null ?
                this.settings.learner_registration :
                true;
        },
        loginPageBanner() {
            return this.settings.login_page_banner != null ?
                this.settings.login_page_banner :
                "";
        },
        loginPageText() {
            return this.setting.login_page_text != null ?
                this.settings.login_page_text :
                "";
        },
        showTopRated() {
            return this.settings.show_top_rated_courses == 1 ? true : false;
        },
        showTestimonial() {
            return this.settings.show_student_testimonial;
        },
        getTopRatedCourses() {
            return this.settings.top_rated_course;
        },
        getTestimonials() {
            return this.settings.testimonials;
        },
        hasBypass() {
            return this.settings.data_bypass;
        },
        getURI() {
            // //console.log("jinjnj");
            if (
                window.location.hostname == "localhost" ||
                window.location.hostname == "lms-staging.hostville.link"
            ) {
                return process.env.VUE_APP_TENANT_URI;
            } else {
                return window.location.href;
            }
        },
    },
    mounted() {
        //console.log(this.settings)
	  console.log(this.lmsUser);
    },
};
</script>
